import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from 'src/layout/material.module';
import { NgxMaskPipe, provideEnvironmentNgxMask } from 'ngx-mask';
import { AppRoutingModule } from './app.routing';
import { AppLocalStorageService } from './shared/services/app-local-storage.service';
import { NgToastModule } from 'ng-angular-popup';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { SharedModule } from './shared/shared.module';
import { SpinnerService } from './shared/components/spinner/spinner.service';
import { AppHttpInterceptor } from './core/interceptors/app-http.interceptor';

registerLocaleData(localePt);

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgToastModule,
    HttpClientModule,
    SharedModule,
  ],
  declarations: [
    AppComponent,
  ],
  providers: [
    provideEnvironmentNgxMask(),
    NgxMaskPipe,
    AppLocalStorageService,
    DatePipe,
    SpinnerService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppHttpInterceptor,
      multi: true
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'pt-BR'
    },
    {
      provide: MatPaginatorIntl,
      useFactory: () => {
        const paginator = new MatPaginatorIntl();
        paginator.itemsPerPageLabel = 'Itens por página:';
        paginator.nextPageLabel = 'Próxima página';
        paginator.previousPageLabel = 'Página anterior';
        paginator.firstPageLabel = 'Primeira página';
        paginator.lastPageLabel = 'Última página';
        paginator.getRangeLabel = (page: number, pageSize: number, length: number) => {
          if (length === 0 || pageSize === 0) {
            return `0 de ${length}`;
          }
          length = Math.max(length, 0);
          const startIndex = page * pageSize;
          const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
          return `${startIndex + 1} - ${endIndex} de ${length}`;
        };
        return paginator;
      }
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
